const createGoupsOfArray = (arr: any[], perGroup: number) => {
    const numGroups = Math.ceil(arr.length / perGroup);
    return new Array(numGroups).fill('').map((_, i) => arr.slice(i * perGroup, (i + 1) * perGroup));
};
export default createGoupsOfArray;
